/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Metric_Total_ProductsInputs */

const en_inventory_metric_total_products = /** @type {(inputs: Inventory_Metric_Total_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Products`)
};

const es_inventory_metric_total_products = /** @type {(inputs: Inventory_Metric_Total_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productos totales`)
};

/**
* | output |
* | --- |
* | "Total Products" |
*
* @param {Inventory_Metric_Total_ProductsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_metric_total_products = /** @type {((inputs?: Inventory_Metric_Total_ProductsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Metric_Total_ProductsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_metric_total_products(inputs)
	return es_inventory_metric_total_products(inputs)
});